"use client";

import { Alert, Text } from "@zapier/design-system";

import { Notification as NotificationType } from "../types";
import useTimer from "./useTimer";
import styles from "./Notification.module.css";

interface Props {
  index: number;
  notification: NotificationType;
  onDismiss: (id: string) => void;
  timeout: number;
}

/**
 * A popup toast-style notification
 */
export function Notification({ notification, onDismiss, timeout }: Props) {
  const { title, message, type } = notification;

  function handleDismiss() {
    if (notification.onDismiss) {
      notification.onDismiss(notification);
    }
    onDismiss(notification.id);
  }

  const { onPause, onResume } = useTimer(handleDismiss, timeout);

  return (
    <div className={styles.root} onMouseEnter={onPause} onMouseLeave={onResume}>
      <Alert onDismiss={handleDismiss} status={type} variant="toast">
        {title && <strong>{title}</strong>}
        {title && message && <br />}
        {title && message ? (
          <Text type="SmallPrint1" color="GrayWarm9">
            {message}
          </Text>
        ) : (
          <span>{message}</span>
        )}
      </Alert>
    </div>
  );
}
